/*
 * @Author: liuxiuting
 * @Date: 2021-12-21 16:36:59
 * @LastEditors: liuxiuting
 * @LastEditTime: 2026-01-20 15:13:46
 * @FilePath: \carrier\packages\common-mediax\src\apis\ImgLibrary\ImgLibrary.js
 * @Description:
 *
 * Copyright (c) 2023 by 用户/公司名, All Rights Reserved.
 */
import { createAPI } from '@common'

export default {
  // 根据选择版本获取修改痕迹
  getArticlesTracesByVersion: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0wfstjpo0usbdf0wfstjpot0tfmfdu', 'get', config, vconfig),
  // 标引项接口
  getCategoryGetCatTypes: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0dbuFyu0dbuUzqft', 'get', config, vconfig), // 获取分类类型
  getApiDomLabelGetLabelList: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0epnMbcfm0mjtu', 'get', config, vconfig), // 获取稿签列表
  postDomLabelSaveLabel: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0epnMbcfm0tbwf', 'post', config), // 新增/修改稿签
  getDomLabelGetLabel: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0epnMbcfm0mbcfm', 'get', config), // 稿签详情
  postDomLabelGetLabelNameFlag: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0epnMbcfm0difdlMbcfmObnf', 'post', config), // 稿签名称查重
  postDomLabelGetLabelCodeFlag: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0epnMbcfm0difdlMbcfmDpef', 'post', config), // 稿签列码查重
  postDomLabelUpdateLabelValue: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0epnMbcfm0vqebufMbcfmWbmvf', 'post', config), // 更新稿签属性
  postDomLabelDeleteLabel: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0bqj0epnMbcfm0efmfufMbcfm', 'post', config), // 删除稿签
  postDomLabelSortLabel: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0epnMbcfm0tpsu', 'post', config), // 更新排序
  //权限接口接口集合
  getE5AdminDomDoclibs: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0gpmefsFyu0benjo0sppu', 'get', config, vconfig), // 读文档库树
  //权限接口接口集合
  getE5AdminDomDoclibsImg: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0gpmefsFyu0benjo0sppu', 'get', config, vconfig), // 读文档库树图片库
  getE5AdminDomFolders: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0gpmefsFyu0benjo0gpmefst', 'get', config, vconfig), // 读子文件夹树
  getE5AdminDomFoldersImg: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0gpmefsFyu0benjo0gpmefst', 'get', config, vconfig), // 读子文件夹树图片库
  getE5AdminPermissionsActionsFolder: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0f60benjo0qfsnjttjpot0bdujpot0gpmefs',
      'get',
      config,
      vconfig
    ), // 读角色权限：文件夹操作权限
  getE5AdminPermissionsActionsFolderImg: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0f60benjo0qfsnjttjpot0bdujpot0gpmefs',
      'get',
      config,
      vconfig
    ), // 读角色权限：文件夹操作权限
  postE5AdminPermissionsActionsFolder: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0f60benjo0qfsnjttjpot0bdujpot0gpmefs',
      'post',
      config,
      vconfig
    ), // 保存角色权限：文件夹操作权限
  postE5AdminPermissionsActionsFolderImg: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0f60benjo0qfsnjttjpot0bdujpot0gpmefs',
      'post',
      config,
      vconfig
    ), // 保存角色权限：文件夹操作权限
  getLimitSize: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0qipup0hfuMjnjuTj{f', 'get', config, {
      neverLoading: true
    }), //图片上传大小上限
  getExtract: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.sftpvsdf0qjd0fyusbdu', 'post', config, {
      timeout: 60000,
      ...vconfig
    }), // 图片库上传针对tif结尾的图，去单独请求一个接口进行转换格式
  getDomLabelGetRequiredFlag: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0epnMbcfm0sfrvjsfeGmbh', 'post', config), // 判断稿签项是否必填
  getImageModifyParam: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0qipup0jnbhfNpejgzQbsbn', 'get', config), // 判断稿签项是否必填
  getE5FoldersByDocLibs: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0f60gpmefst0cz0epdMjct', 'get', config), // 获取图片根节点
  getE5FoldersByChildren: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0f60gpmefst0dijmesfo', 'get', config),
  getE5FoldersByDocLibsAsset: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0f60gpmefst0cz0epdMjct', 'get', config), // 获取图片根节点
  getE5FoldersByChildrenAsset: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0f60gpmefst0dijmesfo', 'get', config),
  postArticleGetPhotoTime: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0qipup0hfuQipupUjnf', 'post', config, vconfig), // 图片库-获取摄影时间缺省值
  getCategoryTag: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0dbuFyu0ubh', 'get', config, vconfig),
  postCategoryTag: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0dbufhpsz0ubh', 'post', config, vconfig),
  getCatArticleCat: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0dbu0hfuBsujdmfDbut', 'get', config, vconfig),
  getUploadFolder: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0gpmefsFyu0hfuVqmpbeGpmefs', 'get', config, {
      neverLoading: true
    }),
  getMoveFolder: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0qipup0npwf', 'get', config, {
      neverLoading: true
    }),
  postPhotoCopy: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0qipup0dpqz', 'post', config), // 图片库-复制
  // 采编选用查记录
  getSelectedDocs: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0qipup0hfuTfmfdufeEpdt', 'get', config, {
      neverLoading: true
    }),
  getFounderAIImageIndexSwitch: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0gpvoefsBJ0jnbhfJoefyTxjudi',
      'get',
      config,
      vconfig
    ), // 以图搜图开关
  getArticleDetail: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0qipup0efubjm', 'get', config, vconfig), // 稿件详情
  //实体库权限接口结合
  getFolders: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0gpmefsFyu0benjo0gpmefst', 'get', config, vconfig),
  //人脸检测开关
  getFaceDetectSwitch: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0gpvoefsBJ0gbdfEfufduTxjudi',
      'get',
      config,
      vconfig
    ),
  //新建人物提交
  postPersonage: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0qfstpobhf', 'post', config),
  //同名人物检测
  getCheck: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0qfstpobhf0difdl', 'get', config),
  //增加人物库同名分类接口
  getFolderExt: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0gpmefsFyu0bdujpot', 'get', config),
  //保存分类接口
  postFolderExt: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0gpmefsFyu0benjo0gpmefst', 'post', config),

  // 获取人物详情
  getPersonage: (config) => createAPI('customEncryptApiName-1/0nfejby.bttfu0qfstpobhf', 'get', config),
  // 删除人物
  deletePersonage: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0qfstpobhf0efmfuf', 'POST', config),

  // 获取地标详情
  getLandmark: (config) => createAPI('customEncryptApiName-1/0nfejby.bttfu0mboenbsl', 'get', config),
  // 删除地标
  deleteLandmark: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0mboenbsl0efmfuf', 'POST', config),

  // 新建地标/编辑地标
  postLandmark: (config) => createAPI('customEncryptApiName-1/0nfejby.bttfu0mboenbsl', 'post', config),
  // 同名地标检测
  getLandmarkCheck: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0mboenbsl0difdl', 'get', config),

  // 添加文件夹/修改文件夹
  postAddFolderExt: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0gpmefsFyu0benjo0gpmefst', 'POST', config),
  // 获取文件夹详情
  getFolderExtDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0gpmefsFyu0benjo0gpmefst0efubjm', 'get', config),
  // 删除文件夹
  deleteFolderExt: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0gpmefsFyu0benjo0gpmefst', 'delete', config),

  // 人物库/地标库文件夹名称查重
  postFolderExtValidNameExt: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0gpmefsFyu0wbmjeObnfFyu', 'post', config), // 人物库/地标库文件夹名称查重

  getE5ImageFile: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.sftpvsdf0f60jnbhfgjmf', 'get', config, {
      neverLoading: true,
      ...vconfig
    }),

  getPhotoActions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0f60bdujpot', 'get', config, {
      neverLoading: true
    }),

  getPhotoUserlist: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfu0vtfsMjtu', 'get', config, vconfig), // 获取上传人接口

  // 获取图片敏感提示
  getPhotoSensitiveTips: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0qipup0tfotjujwfUjqt', 'get', config, vconfig),

  // 人物库移动
  postPersonageMove: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0qfstpobhf0npwf', 'post', config, vconfig),
  // 地标库移动
  postLandmarkMove: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0mboenbsl0npwf', 'post', config, vconfig),

  // 人物库同步
  postPersonageSync: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0qfstpobhf0tzod', 'post', config, vconfig),
  // 地标库同步
  postLandmarkSync: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0mboenbsl0tzod', 'post', config, vconfig),

  getE5Lists: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0f60mjtut', 'get', config, vconfig),
  postE5Listdata: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0f60mjtuebub', 'post', config, vconfig),
  getE5Conditions: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0f60dpoejujpot', 'get', config, vconfig),

  // 媒资翻库-新建
  postTraversalTag: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0usbwfstbmUbh', 'post', config, vconfig),
  // 媒资翻库-任务详情
  getTraversalTag: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0usbwfstbmUbh', 'get', config, vconfig),
  // 媒资翻库-停止
  postTraversalTagStop: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0usbwfstbmUbh0tupq', 'post', config, vconfig),
  // 媒资翻库-一键翻库/批量标敏感/批量去敏感
  postTraversalTagFilpTag: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0usbwfstbmUbh0gmjqUbh', 'post', config, vconfig),
  // 媒资翻库-稿件翻库状态
  getTraversalTagTaskStatus: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0usbwfstbmUbh0ubtlTubuvt', 'get', config, vconfig),
  // 媒资翻库-查询实体
  getTraversalTagEntityList: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0usbwfstbmUbh0foujuzMjtu', 'get', config, vconfig),
  // 人物库删除/移除媒资
  postPersonageDeleteRel: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0qfstpobhf0efmfufSfmbujpo',
      'post',
      config,
      vconfig
    ),
  // 地标库删除/移除媒资
  postLandmarkDeleteRel: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0mboenbsl0efmfufSfmbujpo', 'post', config, vconfig),
  // 敏感人物翻库列表
  getSensitiveList: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0usbwfstbmUbh0tfotjujwfMjtu',
      'get',
      config,
      vconfig
    ),
  // 媒资相关稿件可浏览权限
  getEntityRelationBrowse: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0foujuzSfmbujpo0cspxtf', 'get', config, vconfig)
}
